import { hideEmail, isStaffEmail } from 'utils/user'

const mask = email => (email ? hideEmail(email) || '' : '')

export const ownerOption = user => {
  const firstName = user?.firstName || ''
  const lastName = user?.lastName || ''
  const email = user?.email || ''
  const name = `${firstName} ${lastName}`.trim()
  return {
    id: user?.id,
    firstName,
    lastName,
    email,
    avatar: user?.avatar || null,
    name: name || mask(email) || 'Unnamed person',
    maskedEmail: mask(email),
  }
}

const splitName = name => {
  const parts = (name || '').trim().split(/\s+/).filter(Boolean)
  return { firstName: parts[0] || '', lastName: parts.slice(1).join(' ') }
}

export const ownerFromAction = owner => {
  if (!owner) return null
  const { firstName, lastName } = owner.firstName || owner.lastName ? owner : splitName(owner.name)
  return ownerOption({ id: owner.id, firstName, lastName, email: owner.email || '', avatar: owner.avatar || null })
}

export const STAFF_NAME = 'Building Passport Support'

export const personLabel = person => {
  if (!person) return ''
  const name = (person.name || `${person.firstName || ''} ${person.lastName || ''}`).trim()
  if (name) return name
  if (person.isStaff || isStaffEmail(person.email)) return STAFF_NAME
  return mask(person.email)
}
